import { useState } from 'react'
import { createModal } from '../ModalFactory'
import { AuthContext, useAuth } from 'context/AuthContext'
import { ModalWrapper } from '../ModalWrapper'
import {
    TabStrip,
    TabStripSelectEventArguments,
    TabStripTab,
} from '@progress/kendo-react-layout'
import GeneralForm from './GeneralForm'
import Translation from 'components/Translation'
import LanguageForm from './LanguageForm'
import { classNames } from 'utils/dom-helpers'
import BookingPageLink from './BookingPageLink'
import BookingPageOptions from './BookingPageOptions'

const ModalProvider = createModal(
    AuthContext,
    'CustomBookingPageModal',
    () => (
        <>
            <i className="feather feather-plus mr-4" />
            <span className="circular">Create</span>
        </>
    ),
    () => (
        <span className="inline-block w-6 h-6 text-primary text-center font-extralight">
            <i className="feather feather-chevron-left " />
        </span>
    )
)

export const CustomBookingPageModalOpener = ModalProvider.Opener
export const CustomBookingPageModalCloser = ModalProvider.Closer

function CustomBookingPageModal() {
    const { CustomBookingPageModal } = useAuth()
    const [selected, setSelected] = useState<number>(0)

    const handleSelect = (e: TabStripSelectEventArguments) => {
        setSelected(e.selected)
    }

    return (
        <ModalProvider.Visible>
            <ModalWrapper>
                <div className={classNames("bg-white shadow-3xl min-w-[90%] sm:rounded-md mx-auto my-4 relative border-2 border-gray-100 flex flex-col overflow-x-hidden" )}>
                    <div className="flex px-4 text-gray-500 z-10 pt-4 bg-opacity-30 pb-3 bg-primary-lighter">
                        <div>
                            <ul className="ml-6 text-xs flex gap-1 breadcrumbs text-gray-400">
                                <Translation
                                    render_as="li"
                                    content_key="homepage"
                                />
                                <Translation
                                    render_as="li"
                                    content_key="service"
                                />
                            </ul>
                            <span
                                className="inline-block self-center text-lg text-primary-dark"
                                onClick={() => {
                                    setSelected(0)
                                    CustomBookingPageModal.setAttributes({})
                                }}
                            >
                                <CustomBookingPageModalCloser className="self-center" />
                                <span className="circular">
                                    <Translation content_key="customize_booking_page" />
                                </span>
                            </span>
                        </div>
                    </div>
                    <TabStrip
                        selected={selected}
                        onSelect={handleSelect}
                        className="z-20 flex"
                        animation={false}
                    >
                        <TabStripTab
                            title={<Translation content_key="general" />}
                            contentClassName="flex"
                        >
                            <div className='flex'>
                                <GeneralForm />
                            </div>
                        </TabStripTab>
                        <TabStripTab
                            title={<Translation content_key="settings.booking_page_options" />}
                            contentClassName="flex w-full"
                        >
                            <div className='flex w-full'>
                                <BookingPageOptions />
                            </div>
                        </TabStripTab>
                        <TabStripTab
                            title={<Translation content_key="language" />}
                        >
                            <div>
                                <LanguageForm/>
                            </div>
                        </TabStripTab>
                        <TabStripTab
                            title={<Translation content_key="settings.booking_page_link" />}
                        >
                            <BookingPageLink />
                        </TabStripTab>
                    </TabStrip>
                </div>
            </ModalWrapper>
        </ModalProvider.Visible>
    )
}

export default CustomBookingPageModal
